import { render, staticRenderFns } from "./Shares.vue?vue&type=template&id=32d8f8a6&"
import script from "./Shares.vue?vue&type=script&lang=js&"
export * from "./Shares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/admin/Docker/apps2/privacy/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32d8f8a6')) {
      api.createRecord('32d8f8a6', component.options)
    } else {
      api.reload('32d8f8a6', component.options)
    }
    module.hot.accept("./Shares.vue?vue&type=template&id=32d8f8a6&", function () {
      api.rerender('32d8f8a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Shares.vue"
export default component.exports